import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../components/elements/Loader'
import Pagination from '../../../../components/elements/Pagination'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import EmptyState from '../../../../components/elements/EmptyState'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import { clearCreatedDesignation, clearUpdatedDesignation, fetchDesignations } from '../../../../store/actions/designationActions'
import NewStaffDesignation from '../../../../components/partials/designations/NewStaffDesignation'
import { fetchDepartments } from '../../../../store/actions/departmentActions'
import { SET_SUCCESS } from '../../../../store/types'
import EditStaffDesignation from '../../../../components/partials/designations/EditStaffDesignation'
import DesignationCard from '../../../../components/partials/designations/DesignationCard'

const StaffDesignations = () => {
    const dispatch = useDispatch()
    const designationsSelector = useSelector((state => state.designations))

    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(30);
    const [creatingDesignation, setCreatingDesignation] = useState(false);
    const [reload, setReload] = useState(0);

    useEffect(() => {
        dispatch(fetchDesignations('', page, perPage))
        dispatch(fetchDepartments('', 0, 0))

        if(designationsSelector.createdDesignation !== null) {
            setCreatingDesignation(false)
            dispatch({
                type: SET_SUCCESS,
                payload: "New designation created successfully!"
            })
            dispatch(clearCreatedDesignation())
        }
        
        if(designationsSelector.updatedDesignation !== null) {
            closeDesignation()
            dispatch({
                type: SET_SUCCESS,
                payload: "Designation updated successfully!"
            })
            dispatch(clearUpdatedDesignation())
        }

        return () => {
            
        };

    }, [dispatch, page, perPage, reload, designationsSelector.createdDesignation, designationsSelector.updatedDesignation]);

    const [activeDesignation, setActiveDesignation] = useState(null);
    const [updatingDesignation, setUpdatingDesignation] = useState(false);

    const openDesignation = (designation) => {
        setActiveDesignation(designation)
        setTimeout(() => {
            setUpdatingDesignation(true)
        }, 50);
    }

    const closeDesignation = () => {
        setUpdatingDesignation(false)
        setTimeout(() => {
            setActiveDesignation(null)
        }, 50);
    }
    
    return (
        <>
            <AdministrationLayout pageTitle={`Designations`}>
                <div className='w-full'>
                <div className='w-full flex justify-between'>
                    <div className='w-9/12'>
                        <h3 className='text-lg font-medium'>Vaatia College Staff Designations</h3>
                        <p className='text-sm'>All staff designations in vaatia college Makurdi. Click on a designation to edit details or create new designations anytime by clicking on the "Create Designation" button</p>
                    </div>
                    
                    <div>
                        <button onClick={()=>{setCreatingDesignation(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                            <PlusIcon className='w-5 h-5' /> Create Designation
                        </button>
                    </div>
                </div>

                {designationsSelector.loadingDesignations
                ? 
                <Loader /> 
                :
                <>
                    {designationsSelector?.designations?.designations && designationsSelector?.designations?.designations?.length > 0 
                    ? 
                        <>
                        <div className='mt-8 mb-5 grid grid-cols-4 gap-8'>
                            {designationsSelector?.designations?.designations?.map((designation, designationIndex) => (
                            <div key={designationIndex}>
                                <DesignationCard designation={designation} openDesignation={()=>{openDesignation(designation)}} deleteDesignation={()=>{}} />
                            </div>
                            ))}
                        </div> 
                        <Pagination 
                            pagination={{
                                perPage, 
                                page,
                                totalItems: designationsSelector.designations.total,
                            }} 
                            changePage={setPage} 
                            updatePerPage={setPerPage}
                        />
                    </>
                    : 
                    <div className='h-[300px] w-full flex items-center justify-center'>
                        <EmptyState emptyStateText='No designations have been created yet. Click on "Create Designation" above to create a new one'></EmptyState>
                    </div>
                    }
                </>}

                </div>
            </AdministrationLayout>

            <ModalDialog
                shown={creatingDesignation} 
                closeFunction={()=>{setCreatingDesignation(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={`Create Staff Designation`}
                dialogTitle='Create a new designation'
                maxWidthClass='max-w-6xl'
                hideActions={true}
            >
                <NewStaffDesignation 
                    reload={()=>setReload(reload+1)}
                    closeFunction={()=>{setCreatingDesignation(false)}} 
                    // session={activeSession}
                />

            </ModalDialog>

            {activeDesignation !== null && <ModalDialog
                shown={updatingDesignation} 
                closeFunction={()=>{setUpdatingDesignation(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={`Update Designation`}
                dialogTitle={`Update staff designation - ${activeDesignation.name}`}
                maxWidthClass='max-w-6xl'
                hideActions={true}
            >
                <EditStaffDesignation 
                    reload={()=>setReload(reload+1)}
                    closeFunction={()=>{closeDesignation()}} 
                    designation={activeDesignation}
                />

            </ModalDialog>}
        </>
    )
}

export default StaffDesignations